// extracted by mini-css-extract-plugin
export default {"header":"mW_yxd","hasSwitchPlanNotification":"Fv9I_n","withBoxShadow":"EZpzzV"};